export enum AppRoutes {
  PATIENTS = 'patients',
  DEVICES = 'devices',
  DOCTORS = 'doctors',
  SAMPLES = 'samples',
}
